import { CertificateTypeContent } from './CertificateTypeRecord';
import { certificateTypeRegistry, getCertificateHolders } from '../data/certificateTypes';
import { usePageMeta } from '../hooks/usePageMeta';

// /certificates — browse every issued certificate, one table per
// registered certificate track (see src/data/certificateTypes). Adding a
// new track only needs a new data file there, this page picks it up
// automatically, no route change needed.
//
// This is the "browse" half of certificate verification; the "look up one
// specific person" half is /verify, see VerifyPage.jsx and
// VerifyRecordPage.jsx. Keep these two concerns separate, see "Diplomas vs
// Certificates" in CLAUDE.md.
export default function CertificatesPage() {
  const types = Object.values(certificateTypeRegistry);

  usePageMeta(
    'Certificates',
    'Browse every Six Sigma Green Belt and other project-based certificate PSI has awarded, verifiable by Record ID.'
  );

  return (
    <>
      {types.map((type) => (
        <CertificateTypeContent key={type.slug} type={type} holders={getCertificateHolders(type.slug)} />
      ))}
    </>
  );
}
